import script from "./ProjectModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectModal.vue?vue&type=script&setup=true&lang=js"

import "./ProjectModal.vue?vue&type=style&index=0&id=9d7f1aba&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d7f1aba"]])

export default __exports__